module.exports = __webpack_public_path__ + "images/referenzen/imagefilm/chanel_16_9_small.jpg";